<template>
	<div class="container">
		<div class="iv2-page__error">
			<h1 class="iv2-page__error-number">{{ error_status }}</h1>
			<h2 class="iv2-page__error-lead">{{ lead_text }}</h2>
			<p class="iv2-page__error-summary">{{ summary_text }}</p>
			<div class="row clearfix">
				<div class="column full" style="margin: 0 auto;">
					<div style="text-align: center;">
						<span>
							<router-link
								to="/"
								class="iv2-page__error-btn theme__main-btn is-btn is-btn-ghost2 is-upper"
							>{{ btn_text }}</router-link>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			error_status: "403",
			lead_text: "アクセスしようとしたページは表示できませんでした。",
			summary_text:
				"このエラーは、表示するページへのアクセス許可がなかったことを意味します。",
			btn_text: "トップページに戻る",
		};
	},
};
</script>

<style lang="scss">
.iv2-page__error {
	padding-top: 10rem;

	.iv2-page__error-number {
		text-align: center;
		padding: 0 2rem;
		font-size: 5.5rem;
	}

	.iv2-page__error-lead {
		text-align: center;
		font-size: 1.5rem;
		font-weight: 600;
		padding: 2rem 1rem;
		margin: 0;
	}

	.iv2-page__error-summary {
		text-align: center;
		padding: 0 1rem 2rem 1rem;
		margin: 0;
	}

	.iv2-page__error-btn {
		border: 0;
		border-radius: 50px;
		font-size: 18px;
		letter-spacing: 2px;
		padding-top: 15px;
		padding-bottom: 15px;
		width: 300px;
		max-width: 100%;
	}
}

@media (max-width: 1199px) {
	.iv2-page__error {
		height: 80vh;

		.iv2-page__error-lead {
			font-size: 1rem;
		}
	}
}

@media (min-width: 768px) and (max-width: 1199px) {
	.iv2-page__error {
		padding: 14rem 0;
	}
}
</style>